import React from 'react';

import styled from 'styled-components';
import {inject} from 'mobx-react';

import { Title } from '../shared';
import { isIE11OrEdge, isIPhone } from '../../helpers/browser-detection';

import CharactersButtons from './CharactersButtons';

const Animated = styled.div `
    @-webkit-keyframes fadeFromLeft {
        from {
            opacity: 0;
            -webkit-transform: translate3d(-5%, 0, 0);
            transform: translate3d(-5%, 0, 0);
        }  
        to {
            opacity: 1;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes fadeFromLeft {
        from {
            opacity: 0;
            -webkit-transform: translate3d(-5%, 0, 0);
            transform: translate3d(-5%, 0, 0);
        }  
        to {
            opacity: 1;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }

    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-name: fadeFromLeft;
    animation-name: fadeFromLeft;
`;

const Components = {
    default: (props) => <Animated {...props} />,
    ie: (props) => <div {...props} />
}

const mapper = (stores) => ({
    intl: stores.intl.dictionary,
    character: stores.characters.character,
})

export default inject(mapper)(({intl, character: { id, name, description, tabIndex } = {}}) => {
    let Component = Components['default'];

    if (isIE11OrEdge() || isIPhone()) Component = Components['ie'];

    let KEY = `character-info-${id}`;

    return (
        <div key={KEY} className="col-md-6">
            <Title tabIndex={1}>{intl['LOCALE.CHARACTERES']}</Title>
            <CharactersButtons />
            <Component>
                <Title as="h5" style={{ paddingTop: '0.5em', textTransform: 'capitalize' }} tabIndex={tabIndex}>{name}</Title>
                <span dangerouslySetInnerHTML={{__html: intl[description]}} tabIndex={tabIndex} />
            </Component>
        </div>
    )
})